// extracted by mini-css-extract-plugin
module.exports = {"body":"duBtRc","arrow":"c_hEPEI","b2bArrow":"AOdI0x","arrowUp":"iJ_nrI","text":"FUCf_s","b2bText":"oMreIt"};